import { getConsent, getConsentRecord } from './consent';
import { marketingEventProperties } from './eventPolicy';
import { isCurrentAnalyticsDocumentSensitive } from './sensitiveDocument';

interface CaptureClient { capture(event: string, properties?: Record<string, unknown>): unknown }
export function marketingConsentScope(): string | null {
  if (getConsent() !== 'accepted' || isCurrentAnalyticsDocumentSensitive()) return null;
  const record = getConsentRecord();
  return record ? `${record.consentVersion}:${record.policyVersion}:${record.decisionId ?? record.timestamp}` : null;
}
export function createMarketingCapture(client: CaptureClient, scope = marketingConsentScope) {
  const capture = (event: string, properties?: Record<string, unknown>) => {
    if (!scope()) return;
    const clean = marketingEventProperties(event, properties);
    if (!clean) return;
    try { client.capture(event, clean); } catch { /* Optional analytics cannot interrupt a user action. */ }
  };
  return {
    capture,
    captureScope() {
      const initial = scope();
      return (event: string, properties?: Record<string, unknown>) => {
        if (initial && initial === scope()) capture(event, properties);
      };
    },
  };
}
